import React from 'react';
import {useTranslation} from 'react-i18next';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import EmptyRow from '../../../components/Simple/EmptyRow';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import generateIcon from '../../../assets/images/generate.png';
import RowLayout from '../../../components/Layouts/RowLayout';
import SMCLabel from '../../../components/Simple/SMCLabel';
import {AdministratorCreateSchema} from '../../../api/DBSchema/Administrator';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCPasswordInput from '../../../components/Simple/SMCPasswordInput';

function AdministratorWizardBody({
    onCancel,
    onFinish,
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        uid, setUid,
        firstName, setFirstName,
        lastName, setLastName,
        email, setEmail,
        role, setRole,
        password, setPassword,
        isTwoStepAuthenticationEnabled
    } = wizardVars;

    return (
        <>
            <SMCModalBody lineHeight="22px" labelWidth={200}>
                <SMCLabel>{t('SMP.CREATE_NEW_ADMIN.LINE1')}</SMCLabel>
                <SMCLabel>{t('SMP.CREATE_NEW_ADMIN.LINE2')}</SMCLabel>
                
                <EmptyRow />

                {/* User ID */}
                <RowLayout>
                    <SMCTextInput
                        label={t('SMC_USER_UID')}
                        value={uid}
                        onChange={e => setUid(e.target.value)}
                    />
                    <SMCButton
                        onClick={() => {setUid('user'+Math.random().toString(10).slice(-3))}}
                    >
                        <img src={generateIcon} alt="generate" />
                    </SMCButton>
                </RowLayout>
                {/* First Name */}
                <SMCTextInput
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    label={t('SMC_USER_FNAME')}
                />
                {/* Last Name */}
                <SMCTextInput
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    label={t('SMC_USER_LNAME')}
                />
                {/* Email */}
                <SMCTextInput
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    label={t('SMC_USER_EMAIL')}
                />

                <EmptyRow />
                
                <SMCLabel>{t('SMP.CREATE_NEW_ADMIN.LINE3')}</SMCLabel>
                
                <EmptyRow />
                
                {/* Role */}
                <SMCSelect
                    value={role}
                    onChange={e => setRole(e.target.value)}
                    label={t('SMP.CREATE_NEW_ADMIN.TYPE')}
                >
                    <SMCOption value={AdministratorCreateSchema.roleValues.administrator}>{t('SMC_ADMIN_ROLE_Administrator')}</SMCOption>
                    <SMCOption value={AdministratorCreateSchema.roleValues.readOnly}>{t('SMC_ADMIN_ROLE_ReadOnly')}</SMCOption>
                    <SMCOption value={AdministratorCreateSchema.roleValues.multiDomain}>{t('SMC_ADMIN_ROLE_MultiDomain')}</SMCOption>
                    <SMCOption value={AdministratorCreateSchema.roleValues.multiDomainReadOnly}>{t('SMC_ADMIN_ROLE_MultiDomainReadOnly')}</SMCOption>
                </SMCSelect>
                {/* Password */}
                <SMCPasswordInput
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    label={t('SMC_USER_PASS')}
                    allowPasswordPeek={true}
                />
                <SMCCheckbox
                    disabled
                    checked={isTwoStepAuthenticationEnabled}
                    label={t('SMP.USERWIZ.NEW_USER_LINE3_3')}
                    labelPosition="start"
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default AdministratorWizardBody;